import $ from 'jquery'
import autosize from 'autosize'

const onPageChange = () => {
  addAutosize()
  // fileStyle(); // TODO: check if used
}

window.onPageChange = onPageChange

const expandUserFieldGroup = (selector) => {
  $(selector).addClass('show');
  $(`[data-bs-target="#${$(selector).attr('id')}"]`).attr('aria-expanded','true')
  $(`[data-bs-target="#${$(selector).attr('id')}"]`).removeClass('collapsed')
}

window.expandUserFieldGroup = expandUserFieldGroup

// http://www.jacklmoore.com/autosize/
const addAutosize = () => {
  autosize($('textarea'))
  // https://www.pivotaltracker.com/story/show/108947862
  document.querySelectorAll('.card').forEach(card => {
    card.addEventListener('shown.bs.collapse', event => {
      autosize.update(document.querySelectorAll('textarea'))
    })
  })
}

Ready(() => {
  onPageChange()
})

// http://markusslima.github.io/bootstrap-filestyle/#
// function fileStyle() {
//   var text = I18n.t("js.filestyle.choose_file", { defaultValue: "Choose file…" });
//   $(":file").not(".not-filestyle").filestyle({ buttonText: text, buttonBefore: true, buttonName: "btn btn-info btn-file" });
// }
